import { BadgeColor } from "@/components/catalyst/badge";

export type AdTabId = "active" | "inactive" | "all";

/**
 * A deal is active while any one of its channels is still delivering, so the
 * tabs filter on that rather than on a status — `undefined` means no filter.
 */
export const adTabs: {
  id: AdTabId;
  active: boolean | undefined;
  badgeColor: BadgeColor;
}[] = [
  { id: "active", active: true, badgeColor: "green" },
  { id: "inactive", active: false, badgeColor: "yellow" },
  { id: "all", active: undefined, badgeColor: "zinc" },
];

export function adTabActive(tab: AdTabId): boolean | undefined {
  return adTabs.find((adTab) => adTab.id === tab)?.active;
}
